module.exports = __webpack_public_path__ + "static/media/hero-screenshot-1.8d3e7afb.jpg";